import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  GetHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_HolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `HolidayMasterInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetCompanyHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `CompanyHolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveCompanyHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompanyHolidayMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetStateHolidayHistory(Detail: any) {
    return this.http.post<any>(environment.API_URL + `StateHolidayMaster_SelectByYear/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  
  GetStateHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_StateHolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveStateHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `StateHolidayMaster/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetClientHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ClientHolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveClientHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ClientHolidayMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetSiteHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `SiteHolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveSiteHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `SiteHolidayMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetBranchHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BranchHolidayMaster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveBranchHoliday(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BranchHolidayMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetHolidayDetailsOnID(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_GetHolidayDetails/OnId`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  BulkHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `HolidayMasterBluk/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  BulkCompanyHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompanyHolidayMasterBluk/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  BulkStateHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_StateHolidayMasterBluk/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  BulkBranchHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BranchHolidayMasterBluk/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  BulkClientHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ClientHolidayMasterBlukInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  BulkSiteHolidayInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteHolidayMasterBlukInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //Commented Because having a Common Function in Download Sample Service 
  // ESS_HolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `ESS_HolidayMasterBlukSelect/Get`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }
  // ESS_CompanyHolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `ESS_CompanyHolidayMasterBlukSelect/Get`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }
  // ESS_StateHolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `ESS_StateHolidayMasterBlukSelect/Get`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }
  // ESS_BranchHolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `ESS_BranchHolidayMasterBlukSelect/Get`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }

  // ESS_ClientHolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `Ess_ClientHolidayBulkSelect/Select`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }
  // ESS_SiteHolidayMasterBlukSelect(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `Ess_SiteHolidayBulkSelect/Select`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }
}
